// TODO use axios and add setup-api with axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URI
import api from "@/api/api";
import type { ZApplication, ZApplicant } from '@schemas/application.schemas';

export default {
  // locally we have a proxy from /api to VUE_APP_API_PROXY_TARGET / which is http://localhost:3000
  endpointUrl: "applications",
  /**
   * Apply for an event
   * @param eventId
   * @param applicants
   * @param message
   */
  async apply(eventId: string, applicants: ZApplicant[], message: string): Promise<ZApplication> {
    if (!eventId) {
      throw new Error(`EventId is required`);
    }
    try {
      const payload = {
        eventId,
        applicants,
        message
      }
      return await api.postDocument<ZApplication>(this.endpointUrl, payload);
    } catch (error) {
      console.error('Error apply:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  },
  /**
   * Update the status of an application
   * @param applicationId
   * @param status
   * @param message
   */
  async updateStatus(applicationId: string, status: string, message: string = ""): Promise<ZApplication> {
    if (!applicationId) {
      throw new Error(`applicationId is required`);
    }
    try {
      const payload = {
        status,
        message
      }
      return await api.patchDocument<ZApplication>(this.endpointUrl + "/" + applicationId + "/status", payload);
    } catch (error) {
      console.error('Error updateStatus:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  },
}
